import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSettings } from '../contexts/SettingsContext';

const SEO = () => {
  const { settings } = useSettings();
  const getValue = (key: string) =>
    settings?.find((s) => s.key === key)?.value || '';

  const title = getValue('meta_title') || 'My App | Modern Laboratory System';
  const description =
    getValue('meta_description') ||
    'Welcome to our modern laboratory management system. Fast. Accurate. Reliable.';
  const keywords = getValue('meta_keywords') || 'laboratory management system, healthcare software, lab automation, patient reports, multi-tenant lab app, diagnostic center';

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  );
};

export default SEO;